<template>
	<v-combobox
		:value="value"
		:background-color="backgroundColor"
		:clearable="clearable"
		:dense="dense"
		:hide-details="hideDetails"
		:items="items"
		:label="label"
		:outlined="outlined"
		v-bind="$attrs"
		v-on="unhandled_events"
		@input="on_input"
	>
		<slot />
	</v-combobox>
</template>

<script>
export default {
	name: 'KCombobox',
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			default: undefined
		},
		backgroundColor: {
			type: String,
			default: undefined
		},
		clearable: {
			type: Boolean,
			default: false
		},
		dense: {
			type: Boolean,
			default: false
		},
		hideDetails: {
			type: [Boolean, String],
			default: 'auto'
		},
		items: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: undefined
		},
		outlined: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		on_input(value) {
			this.$emit('input', value)
		}
	},
	computed: {
		unhandled_events() {
			const { input, ...listeners } = this.$listeners
			return listeners
		}
	}
}
</script>
